"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDto = void 0;
class UserDto {
    constructor(args) {
        if (args) {
            this.id = args.id;
            this.createdAt = args.createdAt;
            this.updatedAt = args.updatedAt;
            this.email = args.email;
            this.emailVerified = args.emailVerified;
            this.status = args.status;
            this.appLang = args.appLang;
            this.userRole = args.userRole;
            this.authTokens = args.authTokens;
            this.userTokens = args.userTokens;
            this.magicLinkTokens = args.magicLinkTokens;
            this.lastLogins = args.lastLogins;
            this.username = args.username;
            this.firstName = args.firstName;
            this.lastName = args.lastName;
            this.description = args.description;
            this.phonePrefix = args.phonePrefix;
            this.phonePrefixAfter = args.phonePrefixAfter;
            this.phoneNumber = args.phoneNumber;
            this.imageUrl = args.imageUrl;
            this.jobTitle = args.jobTitle;
            this.birthday = args.birthday;
            this.birthPlace = args.birthPlace;
            this.birthName = args.birthName;
            this.formerPlace = args.formerPlace;
            this.gender = args.gender;
            this.currentHashedRefreshToken = args.currentHashedRefreshToken;
            this.socialProviders = args.socialProviders;
            this.addresses = args.addresses;
        }
    }
}
exports.UserDto = UserDto;
